import * as fromPerfilIni from '../../actions/AdmMapa/perfilInicio.actions';
import { PerfilInicio } from 'src/app/models/SicarMap/perfilInicio.model';


export interface PefilIniState {
    perfilIni: PerfilInicio;
    estado: string;
    loaded: boolean;
    loading: boolean;
    error: any;
}

const initialStatePI: PefilIniState = {
    perfilIni: null,
    estado: '',
    loaded: false,
    loading: false,
    error: null
};
export function perfilInicReducer(state = initialStatePI, action: fromPerfilIni.perfilIniAcciones): PefilIniState {
    switch (action.type) {
        case fromPerfilIni.PerfilIniActionTypes.GET_PERFIL_INI:
            return {
                ...state,
                estado: 'GetPerfil',
                loading: true,
                loaded: false,
                error: null
            };
        case fromPerfilIni.PerfilIniActionTypes.GET_PERFIL_INI_SUCCESS:
            return {
                ...state,
                estado: 'GetPerfilSucces',
                loading: false,
                loaded: true,
                perfilIni: {...action._perfilIni}
            };
        case fromPerfilIni.PerfilIniActionTypes.GET_PERFIL_INI_FAILURE:
            return {
                ...state,
                estado: 'GetPerfilFailure',
                loaded: false,
                loading: false,
                error: {
                    status: action.payload.status,
                    message: action.payload.message,
                    url: action.payload.url
                }
            };
      default: {
        return state;
      }
    }
  }
